import React from "react";
import { Modal, notification } from "antd"; // Import Modal from Ant Design
import { useRejectCandidates } from "utils";

interface DislikeButtonProps {
    selectedPool: number | null;
    selectedCandidates: number[];
}

const DislikeButton: React.FC<DislikeButtonProps> = ({ selectedPool, selectedCandidates }) => {
    const { rejectCandidates, loadingReject, error, success } = useRejectCandidates();

    const confirmRejectCandidates = () => {
        Modal.confirm({
            title: "Reject Candidates",
            content: "Are you sure you want to reject the selected candidates?",
            okText: "Yes",
            cancelText: "No",
            onOk: handleRejectCandidates, // Call handleRejectCandidates if confirmed
        });
    };

    const handleRejectCandidates = async () => {
        if (selectedPool !== null && selectedCandidates.length > 0) { 
            await rejectCandidates({ selectedPool, selectedCandidates });
        }
    };

    return (
        <button onClick={confirmRejectCandidates} className="text-text-quaternary w-8 h-8 flex items-center justify-center hover:bg-[#F9F5FF] hover:text-[#6941C6] rounded-full">
            <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.9025 1V8.7M15.5 6.46V3.24C15.5 2.45593 15.5 2.06389 15.3432 1.76441C15.2052 1.50099 14.9851 1.28681 14.7143 1.15259C14.4065 1 14.0035 1 13.1976 1H5.51196C4.46043 1 3.93467 1 3.51001 1.1872C3.13574 1.3522 2.81766 1.6177 2.59313 1.9525C2.33838 2.33238 2.25843 2.83795 2.09854 3.84909L1.72219 6.22909C1.5113 7.56272 1.40586 8.22953 1.60927 8.74839C1.7878 9.20378 2.12359 9.58458 2.55909 9.82551C3.05526 10.1 3.74871 10.1 5.13561 10.1H5.71485C6.11781 10.1 6.31929 10.1 6.47319 10.1763C6.60858 10.2434 6.71864 10.3505 6.78763 10.4822C6.86605 10.6319 6.86605 10.828 6.86605 11.22V13.2739C6.86605 14.2272 7.66037 15 8.64021 15C8.87392 15 9.08571 14.8661 9.18062 14.6583L11.5987 9.36512C11.7087 9.12437 11.7636 9.004 11.8506 8.91573C11.9274 8.83771 12.0218 8.77805 12.1262 8.74143C12.2445 8.7 12.3799 8.7 12.6506 8.7H13.1976C14.0035 8.7 14.4065 8.7 14.7143 8.54741C14.9851 8.41319 15.2052 8.19901 15.3432 7.93559C15.5 7.63611 15.5 7.24407 15.5 6.46Z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};

export default DislikeButton;
